/*
 * Frontend Javascript
 *
 * All of your custom javascript can be placed below, remember to seperate your functionality into seperate files.
 * Do NOT forgot to add comments above the different functions or functionalities that need explaining.
 *
 */
require('./bootstrap');

var components = './components/';
var utilities = './utilities/';

// require(utilities + 'your-file');
require(utilities + 'breakpoint-size.js');
require(utilities + 'window-width.js');

// Load all components below, for example:
// require(components + 'your-file');
require(components + 'prepare-for-ajax');
require(components + 'navigation');
require(components + 'cookie-consent');
require(components + 'form-animation');
require(components + 'alert-box');
require(components + 'overlay');
require(components + 'slick-slider');
require(components + 'axios-helpers');
require(components + 'scroll-to-element');
require(components + 'chat-popup');
require(components + 'contact-popup');



// WEBPACK FOOTER //
// ./resources/assets/js/frontend/app.js